import React, { useState } from "react";

const UserSearchFilters = ({ onSearch, filters }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleInputChange = (field, value) => {
    const newFilters = { ...localFilters, [field]: value };
    setLocalFilters(newFilters);
    
    // Debounce search for better performance
    clearTimeout(window.searchTimeout);
    window.searchTimeout = setTimeout(() => {
      onSearch(newFilters);
    }, 300);
  };

  const handleSort = (sortBy) => {
    const sortDir = localFilters.sortBy === sortBy && localFilters.sortDir === "asc" 
      ? "desc" 
      : "asc";
    
    const newFilters = { ...localFilters, sortBy, sortDir };
    setLocalFilters(newFilters);
    onSearch(newFilters);
  };

  const clearFilters = () => {
    const clearedFilters = {
      search: "",
      sortBy: "lastLogin",
      sortDir: "desc"
    };
    setLocalFilters(clearedFilters);
    onSearch(clearedFilters);
  };

  return (
    <div className="user-search-filters">
      <div className="search-row">
        <div className="search-input-group">
          <input
            type="text"
            placeholder="Search by name, email, or WhatsApp number..."
            value={localFilters.search}
            onChange={(e) => handleInputChange("search", e.target.value)}
            className="search-input"
          />
          {localFilters.search && (
            <button 
              className="clear-search"
              onClick={() => handleInputChange("search", "")}
            >
              ✕
            </button>
          )}
        </div>

        <button className="btn-clear" onClick={clearFilters}>
          Clear All
        </button>
      </div>

      <div className="sort-controls">
        <span>Sort by:</span>
        {[
          { key: "name", label: "Name" },
          { key: "email", label: "Email" },
          { key: "lastLogin", label: "Last Login" },
          { key: "createdAt", label: "Created Date" }
        ].map(({ key, label }) => (
          <button
            key={key}
            className={`sort-btn ${localFilters.sortBy === key ? 'active' : ''}`}
            onClick={() => handleSort(key)}
          >
            {label}
            {localFilters.sortBy === key && (
              <span className="sort-arrow">
                {localFilters.sortDir === "asc" ? " ↑" : " ↓"}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default UserSearchFilters;